import Linked from 'shared-components/service/Linked'
import styles from './Breadcrumbs.module.css'
import type { DealHuntBreadcrumb } from 'lib/dealhunt/types'
import { dealHuntCategoryHref } from 'lib/dealhunt/url'
import { DEALHUNT_ROOT_SEGMENT } from 'lib/dealhunt/constants'
import { publicConfig } from 'config'

interface BreadcrumbsProps {
  items: DealHuntBreadcrumb[]
}

/** Breadcrumb node types that link to a category page (vs the product leaf). */
export const CATEGORY_TYPES = new Set(['root', 'category', 'subcategory'])

const Breadcrumbs: React.VFC<BreadcrumbsProps> = ({ items }) => {
  const trailingSlash = publicConfig('useTrailingSlash')
  // SoundGuys is audio-only and hides DealHunt's `electronics` taxonomy root from
  // its URLs; hide it from the breadcrumb trail too (so it starts at "Audio").
  const crumbs = (items ?? []).filter(c => c.fullSlug !== DEALHUNT_ROOT_SEGMENT)
  if (!crumbs.length) {
    return null
  }
  return (
    <nav className={styles.breadcrumbs} aria-label="Breadcrumb">
      <ol className={styles.list}>
        {crumbs.map((crumb, i) => {
          const isLast = i === crumbs.length - 1
          const isCategory = CATEGORY_TYPES.has(crumb.nodeType)
          return (
            <li key={crumb.fullSlug} className={styles.item}>
              {isLast || !isCategory ? (
                <span className={styles.current} title={crumb.name}>
                  {crumb.name}
                </span>
              ) : (
                <Linked
                  href={dealHuntCategoryHref(crumb.fullSlug, trailingSlash)}
                  className={styles.link}
                >
                  {crumb.name}
                </Linked>
              )}
              {!isLast && (
                <span className={styles.sep} aria-hidden="true">
                  {'›'}
                </span>
              )}
            </li>
          )
        })}
      </ol>
    </nav>
  )
}

export default Breadcrumbs
